import type { ComponentType } from 'react'
import { ChallengeService } from '@duck/api-definitions'
import { PostgresIcon } from '@components/Workspace/WorkspaceSettings/panels/icons/PostgresIcon'
import { PythonIcon } from '@components/Workspace/WorkspaceSettings/panels/icons/PythonIcon'

const WEAPON_ICON: Record<
  ChallengeService.TaskWeaponsOfChoiceEnum,
  ComponentType<{ className?: string }>
> = {
  [ChallengeService.TaskWeaponsOfChoiceEnum.Sql]: PostgresIcon,
  [ChallengeService.TaskWeaponsOfChoiceEnum.Python]: PythonIcon,
}

export interface WeaponIconProps {
  weapon: ChallengeService.TaskWeaponsOfChoiceEnum
  className?: string
}

/** Brand logo for a weapon of choice — PostgreSQL (SQL) or Python. Decorative. */
export const WeaponIcon = ({ weapon, className }: WeaponIconProps) => {
  const Icon = WEAPON_ICON[weapon]
  return <Icon className={className} />
}
